<template>
	<fieldset :class="['fieldset', variant]">
		<legend class="fieldset__legend" v-if="legend">
			{{ legend }}
		</legend>
		<div class="fieldset__body">
			<slot name="fieldset-content"> </slot>
		</div>
	</fieldset>
</template>

<!----------------- NOTES FOR DEV ------------------------------------
-- this component may consistent of a variety/mixture of form elements. Examples: input field, dropdown, textarea, etc.
------------>

<script>
export default {
	name: 'Fieldset',

	props: {
		legend: {
			type: String,
			default: ''
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * [Description]
    *
    * Global Fieldset
    * Can use SCSS variables = TRUE
    *
    * All fieldset styles and variations are included here.
    *
    * [Table of Contents]
    *
	* BASE.....................This section include the common styles for the fieldset component.
	* 
	* FIELDSET VERTICAL........This section contains the fields items vertical oriented.
	*
	* NO BORDER FIELDSET.......This section includes styles to display the fieldset without any borders.
	*
	* STYLIZED FIELDSET........Styles for the stylized fielset.
	*
	* FULL WIDTH...............Small style block to make a full width fieldset.
	*/

/*------------------------------------*\
  #BASE
\*------------------------------------*/
.fieldset {
	display: inline-block;
	position: relative;
	border: 1px solid $neutral-3;
	border-radius: $form-border-radius;
	font-size: $default-font-size - 2;
	color: $black;
	// removing user agent stylesheet
	margin-inline-start: 0;
	margin-inline-end: 0;
	padding-block-start: $padding-sm;
	padding-block-end: $padding-sm;
	padding-inline-start: $padding-sm;
	padding-inline-end: $padding-sm;

	&__legend {
		padding: 0 $padding-sm;
		font-weight: $medium-font-weight;
		text-transform: capitalize;
	}

	&__body {
		display: flex;
		align-items: flex-start;
		flex-wrap: wrap;
		width: 100%;
	}

	/*------------------------------------*\
      #FIELDSET VERTICAL
    \*------------------------------------*/

	&--vertical &__body {
		flex-direction: column;

		> [class*='-group'] {
			flex-direction: column;
		}
	}

	/*------------------------------------*\
      #NO BORDER FIELDSET
	\*------------------------------------*/
	&--no-borders {
		border: none;
		margin: 0;
		padding: 0;

		.fieldset__legend {
			padding: 0;
			margin-left: 0;
			font-size: $label-font-size;
			font-weight: $label-font-weight;
			color: inherit;
			margin-bottom: $gutter-sm;
		}

		.fieldset__body {
			padding: 0;
		}
	}
	/*------------------------------------*\
      #STYLIZED FIELDSET
	\*------------------------------------*/

	&--styled {
		display: block;
		margin: 0;
		background: $neutral-4;
		padding: $padding-md;
		padding-bottom: $padding-md;
		border: none;
		border-radius: 0;

		.fieldset__legend {
			float: left;
			padding: 0;
			margin-bottom: $gutter-lg;
			font-weight: $bold-font-weight;
		}
		.fieldset__body > :first-child {
			margin-left: 0;
		}
	}

	/*------------------------------------*\
      #FULL WIDTH
    \*------------------------------------*/
	&--full-width {
		display: block;
	}
}
</style>
